import React, { useRef, useCallback, useEffect, useImperativeHandle } from 'react'
import Flip from '../../components/Flip'
// import { rpx1x, handlePress } from '../../utils'

export default React.forwardRef(function Preview({
    rectOptions,
    props,
    zIndex = 0,
    floorData,
}, ref) {
    const { top, left, width, height } = rectOptions
    const { flipImageList, interval, origin_data } = props
    const flipRef = useRef([])
    const timer = useRef(null)
    const isAnimating = useRef(false)

    const startAuto = useCallback(() => {
        timer.current = setInterval(() => {
            allFlipChange(true)
        }, interval * 1000)
    }, [timer.current])

    const stopAuto = useCallback(() => {
        clearInterval(timer.current)
    }, [])

    const allFlipChange = (useLayout) => {
        if (isAnimating.current === true) return
        stopAuto()
        isAnimating.current = true
        flipRef.current.forEach((item, index) => {
            item.flipChange(useLayout === true ? index * 100 : 0)
        })
        setTimeout(() => {
            isAnimating.current = false
            startAuto()
        }, flipRef.current.length * 100)
    }

    useEffect(() => {
        startAuto()
    }, [])

    useImperativeHandle(ref, () => ({
        allFlipChange,
    }))

    return (
        <div
            style={{
                width: width,
                height: height,
                position: 'absolute',
                left: left,
                top: top,
                display: 'flex',
                flexWrap: 'wrap',
                overflow: 'hidden',
            }}
        >
            {
                flipImageList.map((item, index) => {
                    return (
                        <Flip
                            ref={(ref) => (flipRef.current[index] = ref)}
                            list={[{
                                image: item.imageUrl1,
                            }, {
                                image: item.imageUrl2
                            }]}
                            onClick={(idx) => {
                                handlePress(item[`clickUrl${idx + 1}`], floorData)
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: item.imageWidth,
                                height: item.imageHeight,
                            }}
                        />
                    )
                })
            }
        </div>
    )
})